import { MY_SELECTED_TEAM_ } from "header/team-selector/TeamSelector";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import TeamService, { IAPITeam } from "pages/home/teams/services/TeamService";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Observable } from "rxjs";

export const useMemberListController = () => {
    // Get team from Redux or session storage
    const currentTeam = useSelector((state: any) =>
        state?.teamManager?.teams?.currentTeam?.teamName ?? localStorage.getItem(MY_SELECTED_TEAM_)
    );

    const { state, subscribe } = useAsyncAction(() =>
        TeamService.getTeamMembers(currentTeam) as Observable<IAPITeam[]>
    );

    const [prevTeam, setPrevTeam] = useState<string | null>(null);

    useEffect(() => {
        if (!subscribe || !currentTeam || !setPrevTeam) return;

        // Only run if either:
        // 1. This is the first time (prevTeam is null) OR
        // 2. The currentTeam (from redux or session) has changed from the previous value
        if (!prevTeam || prevTeam !== currentTeam) {
            subscribe();
            setPrevTeam(currentTeam);
        }
    }, [currentTeam, subscribe, prevTeam, setPrevTeam]);

    return {
        state,
        subscribe
    };
};